import styled from 'styled-components';

export const StyledWrapper = styled.div`
  > p {
    font-size: 25px;
  }
`;

export const StyledLoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 350px;
`

export const StyledNationalityWrapper = styled.div`
  & > div {
    margin-bottom: 4px;
  }
  margin-bottom: ${(props) => props.hasTermsAndConditionsStep ? '40px' : '0'};
`
